import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import moment from 'moment';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Grid, Button } from '@material-ui/core';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import { useClientContext } from '../../context/client_context';
import Controls from '../controls/Controls';
import { baseUrl } from '../../utils/constants';

function RejectClaimReason(props) {
  const { currDependant } = useClientContext();
  const navigate = useNavigate();
  const { claimId, rejectLevel } = props;
  const [isDisabled, setDisabled] = useState(false);
  //   const [data, setData] = useState({ rejectReason: '' });
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const userRefId = sessionStorage.getItem('userRefId');

  const data = { rejectReason: '' };
  const DependantSchema = Yup.object().shape({
    rejectReason: Yup.string().required('Reason for Rejecting the Claim is Required')
  });

  console.log('claim_ID', claimId, 'rejectLevel', rejectLevel);

  const formik = useFormik({
    initialValues: data,
    enableReinitialize: true,
    validationSchema: DependantSchema,
    onSubmit: (values) => {
      console.log('values in reject', values);
      rejectClaim(values);
    }
  });

  const rejectClaim = (rejects) => {
    setDisabled(true);
    fetch(
      `${baseUrl}/api/claims/rejectClaim?claimId=${claimId}&rejectReason=${rejects.rejectReason}&rejectedBy=${userRefId}&rejectLevel=${rejectLevel}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          notifyPopup(`Dependant Saved Successfully!`, 'success');
          navigate('/dashboard', { replace: true });
        },
        (error) => {
          notifyPopup(`Error in Saving Client!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Controls.Input
              name="rejectReason"
              label="Reason for Claim Rejection"
              multiline
              rows={3}
            />
          </Grid>
          <Grid margin={2} container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={12} sm={3}>
              <Button
                fullWidth
                type="submit"
                variant="outlined"
                disabled={isDisabled}
                startIcon={<CancelPresentationIcon />}
              >
                Reject Claim...
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}

export default RejectClaimReason;
